import { Outlet, Navigate } from 'react-router-dom';
import DashboardLayout from '@/layouts/DashboardLayout';
import { DataContextProvider } from '@/context/context';
import TitleUpdater from '@/components/common/TitleUpdater';
import SnackbarWarper from '@/components/common/SnackbarWarper/SnackbarWarper';
import { getUser } from '@/util/getUser';

const DashboardLayoutRoute = () => {
  const user = getUser();

  if (process.env.NODE_ENV !== 'development' && !user) {
    const pathname = window.location.pathname;
    if (pathname) {
      window.sessionStorage.setItem('redirect', pathname);
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <DataContextProvider>
      <TitleUpdater />
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
      <SnackbarWarper />
    </DataContextProvider>
  );
};

export default DashboardLayoutRoute;
